module.exports = __webpack_public_path__ + "static/media/us-postal.31d0f466.png";